import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Articles API
export const articlesAPI = {
  getAll: async (params = {}) => {
    // Add cache-busting parameter
    const cacheBuster = { ...params, _t: Date.now() };
    const response = await axios.get(`${API}/articles/`, { params: cacheBuster });
    return response.data;
  },
  
  getBySlug: async (slug) => {
    const response = await axios.get(`${API}/articles/${slug}`);
    return response.data;
  },
  
  create: async (articleData) => {
    const response = await axios.post(`${API}/articles/`, articleData);
    return response.data;
  },
  
  delete: async (articleId) => {
    const response = await axios.delete(`${API}/articles/${articleId}/`);
    return response.data;
  }
};

// Media Alerts API
export const mediaAlertsAPI = {
  create: async (alertData) => {
    const response = await axios.post(`${API}/media-alerts/`, alertData);
    return response.data;
  },
  
  getByEmail: async (email) => {
    const response = await axios.get(`${API}/media-alerts/email/${email}/`);
    return response.data;
  },
  
  update: async (alertId, updateData) => {
    const response = await axios.put(`${API}/media-alerts/${alertId}/`, updateData);
    return response.data;
  },
  
  delete: async (alertId) => {
    const response = await axios.delete(`${API}/media-alerts/${alertId}/`);
    return response.data;
  },
  
  getMentions: async (alertId) => {
    const response = await axios.get(`${API}/media-alerts/${alertId}/mentions/`);
    return response.data;
  }
};

// Evidence API
export const evidenceAPI = {
  upload: async (formData) => {
    const response = await axios.post(`${API}/evidence/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  uploadMultiple: async (files, articleId, uploaderName, uploaderEmail) => {
    const uploadPromises = files.map(file => {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('article_id', articleId);
      formData.append('uploader_name', uploaderName);
      formData.append('uploader_email', uploaderEmail);
      formData.append('description', 'Community story photo');
      
      return axios.post(`${API}/evidence/upload`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
    });

    const results = await Promise.all(uploadPromises);
    return results.map(r => r.data);
  },
  
  getByArticle: async (articleId) => {
    const response = await axios.get(`${API}/evidence/article/${articleId}`);
    return response.data;
  },
  
  download: async (evidenceId) => {
    const response = await axios.get(`${API}/evidence/${evidenceId}/download`, {
      responseType: 'blob'
    });
    return response.data;
  },
  
  delete: async (evidenceId) => {
    const response = await axios.delete(`${API}/evidence/${evidenceId}`);
    return response.data;
  }
};

// Rapid Response API
export const rapidResponseAPI = {
  create: async (responseData) => {
    const response = await axios.post(`${API}/rapid-response/`, responseData);
    return response.data;
  },
  
  get: async (responseId) => {
    const response = await axios.get(`${API}/rapid-response/${responseId}`);
    return response.data;
  },
  
  getAll: async (params = {}) => {
    const response = await axios.get(`${API}/rapid-response/`, { params });
    return response.data;
  },
  
  update: async (responseId, updateData) => {
    const response = await axios.put(`${API}/rapid-response/${responseId}/edit`, updateData);
    return response.data;
  },
  
  publish: async (responseId) => {
    const response = await axios.post(`${API}/rapid-response/${responseId}/publish`);
    return response.data;
  },
  
  delete: async (responseId) => {
    const response = await axios.delete(`${API}/rapid-response/${responseId}`);
    return response.data;
  }
};
